export const state = () => ({
	notifications: [],
	meta: {},
	links: {},
	unreadBoolean: false,
	lastPayload: {},
});
export const mutations = {
	setNotifications(state: any, payload: any) {
		state.notifications = payload;
	},

	setMeta(state: any, payload: any) {
		state.meta = payload;
	},

	setLinks(state: any, payload: any) {
		state.links = payload;
	},

	setUnreadBoolean(state: any, payload: any) {
		state.unreadBoolean = payload;
	},

	setLastPayload(state: any, payload: any) {
		state.lastPayload = payload;
	},
};
export const getters = {
	getNotifications: (state: any) => state.notifications,
	getMeta: (state: any) => state.meta,
	getLinks: (state: any) => state.links,

	getUnreadBoolean: (state: any) => state.unreadBoolean,
};
export const actions = {
	checkForUnread(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/notifications', { params: { read: 0 } })
				.then((res) => {
					if (!res.data.data.length) {
						state.commit('setUnreadBoolean', false);
					} else {
						state.commit('setUnreadBoolean', true);
					}
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getNotifications(state: any, payload: any) {
		state.commit('setLastPayload', payload);
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/notifications', { params: { ...payload } })
				.then((res) => {
					state.commit('setNotifications', res.data.data);
					state.commit('setMeta', res.data.meta);
					state.commit('setLinks', res.data.links);
					state.dispatch('checkForUnread');
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	toggleReadStatus(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('api/notifications/status-toggle', payload)
				.then((res) => {
					state.dispatch('getNotifications', state.state.lastPayload);
					state.dispatch('checkForUnread');
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
